import {createExerciseSelector} from "./exerciseSelector";
import {findPrefillResponse} from "./exercisePickerShared";

function setupStandardsExerciseSelectors() {
    const initialExercises = findPrefillResponse("/api/exercises");
    const selectors = document.querySelectorAll("[data-exercise-selector]");

    for (let i = 0; i < selectors.length; i++) {
        createExerciseSelector({
            root: selectors[i],
            initialExercises: initialExercises,
        });
    }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupStandardsExerciseSelectors);
} else {
    setupStandardsExerciseSelectors();
}
